import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { ColumnModel } from "../../../services/api/types/common/models/ColumnModel";
import TableList from "../../../components/organisms/TableList";
import { useHandleMedicationsPendingSignOffs } from "../../medications/hooks/useHandleMedicationsPendingSignOffs";
import { PendingSignOffsModel } from "../../../services/api/types/medications/models/PendingSignOffsModel";
import { format } from "date-fns";
import usePagination from "ui/molecules/pagination/usePagination";
import Pagination from "ui/molecules/pagination/Pagination";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { ChevronRightIcon } from "ui/gluestack/icon";
import { useRouter } from "expo-router";
import { MobileTableCard } from "../../../components/organisms/MobileTableCard";

export default function MedicationsTemplate() {
  const router = useRouter();
  const { currentPage, handlePageChange } = usePagination();
  const { data, isLoading } = useHandleMedicationsPendingSignOffs({
    currentPage,
  });
  const columns: ColumnModel<PendingSignOffsModel>[] = [
    {
      title: "Resident",
      dataKey: "resident_name",
      renderCell: (item: PendingSignOffsModel) => (
        <View>
          <Text className="text-base text-typography-900 font-medium">
            {item.resident_name}
          </Text>
        </View>
      ),
    },
    {
      title: "Medication Prescribed",
      dataKey: "title",
      renderCell: (item: PendingSignOffsModel) => (
        <View>
          <Text className="text-base text-typography-900 font-medium">
            {item.title}
          </Text>
        </View>
      ),
    },
    {
      title: "Prescribed by",
      dataKey: "created_by",
      renderCell: (item: PendingSignOffsModel) => (
        <View>
          <Text className="text-base text-typography-900 font-medium">
            {`${item.created_by.first_name} ${item.created_by.last_name}`}
          </Text>
        </View>
      ),
    },
    {
      title: "Date/Time",
      renderCell: (item: PendingSignOffsModel) => (
        <View>
          <Text className="text-base text-typography-900 font-medium">
            {format(new Date(item.created_at), "dd-MM-yyyy HH:mm")}
          </Text>
        </View>
      ),
    },
    {
      colSpan: 1,
      renderCell(item) {
        return (
          <Button
            variant="link"
            size="sm"
            onPress={() =>
              router.push(
                `/residents/${item.resident_id}/medications/${item.id}`,
              )
            }
          >
            <ButtonText>Review</ButtonText>
            <ButtonIcon as={ChevronRightIcon} />
          </Button>
        );
      },
    },
  ];
  return (
    <View>
      <TableList
        columns={columns}
        data={data?.data || []}
        emptyMessage="There are no pending items to sign off."
        showHorizontalRowDivider
        showHorizontalHeaderDivider
        isFetching={isLoading}
        onRowPress={(item) =>
          router.push(`/residents/${item.resident_id}/medications/${item.id}`)
        }
        mobileRenderItem={(item) => (
          <MobileTableCard item={item} columns={columns} key={item.id} />
        )}
      />
      <Pagination meta={data?.meta} onPageChange={handlePageChange} />
    </View>
  );
}
